import React from "react"
import { DatePicker } from "components-design-system"

// hoc
import InputWrapper from "../../hoc/InputWrapper/InputWrapper"

const RJDatePicker = (props) => {
  let { carbonProps, value, onChange, invalid, isTranslation, originalValue } = props

  const variant = invalid ? "error" : undefined
  const jpath = props.id.split(".").join("_")

  let date = value || null
  if (isTranslation && originalValue) {
    date = originalValue
  }

  return (
    <>
      <DatePicker
        status={variant}
        jpath={jpath}
        placeholder={""}
        className="rj-date-picker"
        value={date}
        onChange={(e) => onChange(e, null, "date")}
        allowClear={true}
        disabled={carbonProps?.disabled}
      />
    </>
  )
}

export default InputWrapper(RJDatePicker)
